export enum PdfType {
  DayPort = 'dayPort',
  FullCruiseItinerary = 'fullCruiseItinerary',
}

export enum DownloadPDFTabType {
  ByDay = 'byDay',
  FullCruise = 'fullCruise',
}

export type ExcursionActivityCategory = {
  categoryColor?: string;
  categoryCode?: string;
  categoryTitle?: string;
  categoryDescription?: string;
};

export type DownloadPDFTabCardProps = {
  image?: string;
  imageReference?: string;
  imageAltText?: string;
  description?: string;
  buttonLabel?: string;
  buttonIcon?: string;
};

/** Labels shared by both by-day and full-itinerary PDFs. */
export type DownloadPDFSharedLabelsProps = {
  headerImgReference?: string;
  headerImgAltText?: string;
  keyToSymbolsImgReference?: string;
  keyToSymbolsImgAltText?: string;
  keyToSymbolsLabel?: string;
  ourExcursionsLabel?: string;
  cruiseShipLabel?: string;
  codeLabel?: string;
  excursionDurationLabel?: string;
  priceTypeLabel?: string;
  firstPriceLabel?: string;
  secondPriceLabel?: string;
  minimumNoOfParticipantsRequiredText?: string;
  tourLanguageLabel?: string;
  categoryDescription?: string;
  copyrightFooter?: string;
  generatedLabelDateFooter?: string;
};

/** Labels used only in the by-day PDF (header block). */
export type DownloadPDFByDayLabelsProps = DownloadPDFSharedLabelsProps & {
  cruiseDestinationLabel?: string;
};

/** Labels used only in the full-itinerary PDF (summary table). */
export type DownloadPDFFullCruiseLabelsProps = DownloadPDFSharedLabelsProps & {
  cruiseLabel?: string;
  itinerariesLabel?: string;
  departureFromLabel?: string;
  departureDateLabel?: string;
  dayFieldLabel?: string;
  nightFieldLabel?: string;
};

export type DownloadPDFLabelsProps = DownloadPDFByDayLabelsProps | DownloadPDFFullCruiseLabelsProps;

export type DownloadPDFWrapperProps = {
  id?: string;
  dataComponentName: string;
  pdfDownloadSectionTitle?: string;
  byDayTabTitle?: string;
  fullCruiseTabTitle?: string;
  byDayButtonLabel?: string;
  byDayButtonIcon?: string;
  fullCruiseButtonLabel?: string;
  fullCruiseButtonIcon?: string;
  byDayImage?: string;
  byDayImageReference?: string;
  byDayImageAltText?: string;
  byDayDescription?: string;
  fullCruiseImage?: string;
  fullCruiseImageReference?: string;
  fullCruiseImageAltText?: string;
  fullCruiseDescription?: string;
  byDayHeaderImgReference?: string;
  byDayHeaderImgAltText?: string;
  byDayKeyToSymbolsImgReference?: string;
  byDayKeyToSymbolsImgAltText?: string;
  byDayKeyToSymbolsLabel?: string;
  byDayOurExcursionsLabel?: string;
  byDayCruiseDestinationLabel?: string;
  byDayCruiseShipLabel?: string;
  byDayCodeLabel?: string;
  byDayExcursionDurationLabel?: string;
  byDayPriceTypeLabel?: string;
  byDayFirstPriceLabel?: string;
  byDaySecondPriceLabel?: string;
  byDayMinimumNoOfParticipantsRequiredText?: string;
  byDayTourLanguageLabel?: string;
  byDayCategoryDescription?: string;
  byDayCopyrightFooter?: string;
  byDayGeneratedLabelDateFooter?: string;
  fullCruiseHeaderImgReference?: string;
  fullCruiseHeaderImgAltText?: string;
  fullCruiseKeyToSymbolsImgReference?: string;
  fullCruiseKeyToSymbolsImgAltText?: string;
  fullCruiseKeyToSymbolsLabel?: string;
  fullCruiseOurExcursionsLabel?: string;
  fullCruiseDayFieldLabel?: string;
  fullCruiseNightFieldLabel?: string;
  fullCruiseCruiseShipLabel?: string;
  fullCruiseCodeLabel?: string;
  fullCruiseExcursionDurationLabel?: string;
  fullCruisePriceTypeLabel?: string;
  fullCruiseFirstPriceLabel?: string;
  fullCruiseSecondPriceLabel?: string;
  fullCruiseMinimumNoOfParticipantsRequiredText?: string;
  fullCruiseTourLanguageLabel?: string;
  fullCruiseCategoryDescription?: string;
  fullCruiseItinerariesLabel?: string;
  fullCruiseDepartureFromLabel?: string;
  fullCruiseDepartureDateLabel?: string;
  fullCruiseCruiseLabel?: string;
  fullCruiseCopyrightFooter?: string;
  fullCruiseGeneratedLabelDateFooter?: string;
  excursionActivityCategories?: ExcursionActivityCategory[];
};
